import React, { useState, useEffect } from 'react';
import Layout from "components/Layout";
import SocialAuth from 'components/SocialAuth';
import FormLogin from 'components/FormLogin';
import ValidSession from 'components/ValidSession';
import SessionFactory from 'factories/Session';
import PopupUpdateUser from 'components/PopupUpdateUser';
import PopupLayout from 'components/PopupLayout';

const Login = () => {

    const [loadData, setLoadData] = useState(false);
    const [dataPage, setDataPage] = useState({});
    //erick
    const[formLoginEmailVisible,setFormLoginEmailVisible]=useState(false);
    const [loginValidation, setLoginValidation] = useState(false);  // Nuevo estado para almacenar el valor de validate
    const [loginData,setLoginData]=useState();
    const [checkboxState] =useState ({
        privacyPoliciesChecked: false,
       termConditionsChecked: false,
       legalOthersChecked: false,  // Nuevo estado

      });
    
      const openPopupUpdateUser= () =>{
        //open popup band title end text de checkbox
   
  
        setLoginValidation(false);
        //console.log("validate login",loginValidation);
        setFormLoginEmailVisible(false); 

    }
    
    const handleLoginData = (loginDataUpdate) => {
        // Aquí puedes hacer lo que necesites con el payload en el componente padre
        console.log('Payload recibido en Login:', loginDataUpdate);

        // Puedes abrir el popup o hacer cualquier otra cosa con el payload
        setLoginData(loginDataUpdate);
    };
    
    const visibleForm = ()=>{
       
        setFormLoginEmailVisible(!formLoginEmailVisible);
    
    }
    
      
        //end erick
    useEffect(() => {
        setDataPage({ session: SessionFactory.validation() });
        setLoadData(true);
    }, []);

    return (
        <div className="login">
            {loadData && <ValidSession dataSession={dataPage.session?null:{any:true}} customPath={'/home'}/>}
            <Layout showBanner={false} showContent={loadData && !dataPage.session? true : false}>
                <section className="authentication">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-10 ml-lg-auto mr-lg-auto">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="text-center red mt-4 mb-4">Iniciar sesión</h2>
                                        <p className="text-center mt-4 red-dark">Puedes ingresar con tu cuenta de Metro.pe</p>
                                        <div className="col-12 col-lg-5 ml-lg-auto mr-lg-auto mt-lg-5 mt-3 ">
                                        <SocialAuth actionCall="login" disablebuttons={false} legal={checkboxState}  showFacebook={false} handleLoginValidation={setLoginValidation} handleLoginData={handleLoginData}/>
                                        <button className="btn btn-conect-social-ingresar mt-3 btn-default btn-sm no-hover hover-wong btn-block" onClick={visibleForm} >Ingresar con Email y Contraseña</button>
                                        </div>
                                        {
                                        formLoginEmailVisible?
                                        <div className="col-12 col-lg-5 ml-lg-auto mr-lg-auto mt-lg-5 mt-5">
                                            <FormLogin handleLoginValidation={setLoginValidation} handleLoginData={handleLoginData}/>
                                        </div>
                                        :
                                        
                                        <div className="col-lg-8  ml-lg-auto mr-lg-auto mt-lg-4 mt-3">
                                    
                                       
                                      {/*  <div className="col-12 col-lg-9 ml-lg-auto mr-lg-auto mt-lg-4 mt-3">
                                       {visibleLegalSocialTooltip[2] &&<MsgError msg="*opcional*"  />}
                                       <TermPolCheckbox textId = "data-protection" handlegetValueCheked={handleDisButtSocAut} />
                                       
                                       </div> */}
            
                                         
                                   </div>
                                       
                                       
                                        } 
                                    </div>   
                                </div>
                                <div className="row footer-links">
                                    <div className="col-12 col-lg-4 ml-lg-auto mr-lg-auto mt-lg-5 mt-3">
                                        <p className="legend-login text-center">¿No tiene una cuenta? <a href="/register">Regístrese</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
            <PopupLayout isShowwing={loginValidation} showingCallback={openPopupUpdateUser}>
                <PopupUpdateUser execActionConfirm={openPopupUpdateUser} titleText={"Actualizacion de Datos"} popupLegalText={"hola"} loginData={loginData}  />
             </PopupLayout>
        </div>
    )
};

export default Login;
